export const locale = {
  lang: 'en-CA',
  data: {
    ORDER_MATERIALS: {
      TITLE: 'Add equipment',
      TITLE_CREATE: 'Add equipment',
      LEFT_LIST_LABEL: 'Drag & drop or use the + button to add equipment',
      RIGHT_LIST_LABEL: 'List of equipments to add',
      CREATE_PRODUCT: 'Create an equipment',
      SEARCH: 'search by internal name, external name or material code',
      SEARCH_MATERIAL: 'Perform a search for your equipment.',
      CATEGORY_FILTER: 'Equipment category',
      TAGS_FILTER: 'Tags',
      NO_SEARCH_RESULTS: 'No results for your search.',
      NO_SEARCH_RESULTS_TRY_AGAIN: 'Please try something else.',
    },
  },
};
